export default __webpack_public_path__ + "static/media/mTop_3_c1.a434f68f.jpeg";